var modalId = 1;
export function makeModal(type, options) {
    return {
        id: modalId++,
        type: type,
        options: options,
    };
}
//# sourceMappingURL=makeModal.js.map